export namespace SopActions {
  export class SetAllSop {
    static readonly type = '[Sop] SetAllSop';
    constructor() {}
  }
}
